import { Box, Theme } from "@outschool/backpack";
import { useSearchQuery } from "@outschool/ui-components-website";
import { TrackingProperties } from "@outschool/ui-legacy-component-library";
import React from "react";

import { ListingCard } from "../listings/ListingCard";

type ElementOfArray<T extends unknown[]> = T extends (infer U)[] ? U : never;

export type CardGridListings = (
  | (ElementOfArray<ReturnType<typeof useSearchQuery>["exactListings"]> & {
      searchUid?: string;
    })
  | (ElementOfArray<ReturnType<typeof useSearchQuery>["otherListings"]> & {
      searchUid?: string;
    })
)[];

export default function CardGrid({
  listings,
  trackingLabel,
  trackingProperties,
  variant,
  rowCount = 2,
  isTutoringCLP = false,
}: {
  listings: CardGridListings;
  trackingLabel: string;
  trackingProperties: TrackingProperties;
  variant?: string;
  rowCount?: number;
  isTutoringCLP?: boolean;
}) {
  const columnCount = 4;

  return (
    <Box
      sx={(theme: Theme) => ({
        margin: "auto",
        display: "grid",
        gridTemplateColumns: isTutoringCLP
          ? "1fr 1fr"
          : "repeat(auto-fit, 242px)",
        gridTemplateRows: `repeat(${rowCount}, auto)`,
        gridAutoRows: "0px",
        gridColumnGap: "20px",
        justifyContent: "space-between",
        overflow: "hidden",
        [theme.breakpoints.only("md")]: {
          justifyContent: "space-around",
        },
        [theme.breakpoints.down("md")]: {
          gridTemplateColumns: "1fr",
        },
        "> a": {
          marginBottom: "20px",
        },
      })}
    >
      {listings.map((listing, index) => (
        <Box
          key={listing.activity.uid}
          sx={(theme: Theme) => ({
            paddingY: "1em",
            [theme.breakpoints.down("md")]: {
              paddingBottom: 0,
            },
          })}
        >
          <ListingCard
            listing={listing}
            // @ts-ignore TS(2322): Type 'null' is not assignable to type 'number'.
            carouselRowNum={null}
            trackingLabel={trackingLabel}
            trackingOrder={index + 1}
            trackingProperties={{
              ...trackingProperties,
              searchUid: listing.searchUid ?? trackingProperties.searchUid,
            }}
            openInNewTab
            passSectionUid={false}
            listingIndex={index}
            variant={variant}
            isTutoringCLP={isTutoringCLP}
          />
        </Box>
      ))}
      <BlankCards count={columnCount - listings.length} />
    </Box>
  );
}

function BlankCards({ count }: { count: number }) {
  if (count <= 0) {
    return <></>;
  }

  const blanks = [];
  for (let i = 0; i < count; i++) {
    // @ts-ignore TS(2345): Argument of type 'Element' is not assignable to pa... Remove this comment to see the full error message
    blanks.push(<Box key={i} sx={{ width: "242px" }}></Box>);
  }

  return <>{blanks}</>;
}
